import { DEFAULT_LOCALE, DEFAULT_CURRENCY } from '@tsgecart/config';

const currencyFormatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
  style: 'currency',
  currency: DEFAULT_CURRENCY,
  maximumFractionDigits: 2,
});

const numberFormatter = new Intl.NumberFormat(DEFAULT_LOCALE);

/**
 * Integer paise -> a formatted currency string. Division only ever happens
 * here, at the final display step -- every value upstream (backend DTO,
 * this function's own input) stays an integer paise count; this function
 * itself never re-enters arithmetic on the formatted result.
 */
export function formatPaise(paise: number): string {
  return currencyFormatter.format(paise / 100);
}

export function formatCount(value: number): string {
  return numberFormatter.format(value);
}

/** Renders a UTC ISO instant in the viewer's local time zone -- the Worker's date-range boundaries are UTC (see docs/admin-analytics-definitions.md), but nothing in the UI should force the viewer to read UTC. */
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString(DEFAULT_LOCALE, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(DEFAULT_LOCALE, { dateStyle: 'medium' });
}
